import type { FormPostSubmitFields } from "../../translation-keys/post-submit-text-keys.js";

const BlindHeading ="Welcome Back!";
const BlindSubmitBody ="Klicken Sie auf die Schaltfläche unten, um den Download zu starten.";
const Heading ="Vielen Dank für Ihr Interesse!";
const Body ="We have sent an email to the provided address with a download link to the requested asset. You may also click the button below to start your download.";
const Download = "Download Now";
const PostFormFieldMap: FormPostSubmitFields = {
  "document-BlindSubmitHeading": BlindHeading,
  "document-BlindSubmitBody": BlindSubmitBody,
  "document-Heading": Heading,
  "document-Body": Body,
  "document-Download": Download,
  "document-landing-page-BlindSubmitHeading": BlindHeading,
  "document-landing-page-BlindSubmitBody": BlindSubmitBody,
  "document-landing-page-Heading": Heading,
  "document-landing-page-Body": Body,
  "document-landing-page-Download": Download,
  "post-event-assets-BlindSubmitHeading": BlindHeading,
  "post-event-assets-BlindSubmitBody": BlindSubmitBody,
  "post-event-assets-Heading": Heading,
  "post-event-assets-Body": "Klicken Sie auf die Schaltfläche unten, um das Video anzusehen.",
  "post-event-assets-Download": "Play Now",
  "ppc-BlindSubmitHeading": BlindHeading,
  "ppc-BlindSubmitBody": BlindSubmitBody,
  "ppc-Heading": "Thank you for filling out our form.",
  "ppc-Body": Body,
  "ppc-Download": Download,
  "case-study-BlindSubmitHeading": BlindHeading,
  "case-study-BlindSubmitBody": BlindSubmitBody,
  "case-study-Heading": "Thank you for filling out the form. Please click the download button below to view your requested resource.",
  "case-study-Body": "",
  "case-study-Download": "Download Your Request",
  "video-BlindSubmitHeading": "Vielen Dank für Ihr Interesse an unseren Inhalten.",
  "video-BlindSubmitBody": "",
  "video-Heading": "Your files are on their way.",
  "video-Body": "The resources are on their way to your email but you can also download them right now. Feel free to continue exploring and learning more about MasterControl and our solutions.",
  "video-Download": Download,
  "video-landing-page-BlindSubmitHeading": BlindHeading,
  "video-landing-page-BlindSubmitBody": BlindSubmitBody,
  "video-landing-page-Heading": "Vielen Dank für Ihr Interesse an unseren Inhalten. Klicken Sie auf die Schaltfläche unten, um das Video anzusehen.",
  "video-landing-page-Body": "Sie haben den Zugang zu allen exklusiven Dokumenten und Videos von MasterControl freigeschaltet. ",//Visit the Resource Center",
  "video-landing-page-Download": Download,
  "video-gated-BlindSubmitHeading": BlindHeading,
  "video-gated-BlindSubmitBody": BlindSubmitBody,
  "video-gated-Heading": "Vielen Dank für Ihr Interesse an unseren Inhalten. Klicken Sie auf die Schaltfläche unten, um das Video anzusehen.",
  "video-gated-Body": "Sie haben den Zugang zu allen exklusiven Dokumenten und Videos von MasterControl freigeschaltet. ", //Visit the Resource Center",
  "video-gated-Download": Download,
  "recommended-resources-BlindSubmitHeading": "Welcome Back! " ,
  "recommended-resources-BlindSubmitBody": "Click the button to download this asset.",
  "recommended-resources-Heading": Heading,
  "recommended-resources-Body": " We have sent an email to the provided address with a download link to the requested asset. You may also click the button to start your download.",
  "recommended-resources-Download": "resource center",
  "general-modal-BlindSubmitHeading": "",
  "general-modal-BlindSubmitBody": "",
  "general-modal-Heading": "Your Requested Resource",
  "general-modal-Body": "Thank you! You will receive an email with your document link or you can download it now.",
  "general-modal-Download": "",
  "ppc-video-Heading": "Thank you for completing the form.",
  "ppc-video-BlindSubmitHeading": "Welcome Back!",
  "ppc-video-BlindSubmitBody": "Click the button below to watch this asset.",
  "ppc-video-Body": "Klicken Sie auf die Schaltfläche unten, um das Video anzusehen.",
  "ppc-video-Download": "Watch the Video"
};
export default PostFormFieldMap;
